import React from "react";

import { Footer, Navigation } from "../components";

type Props = {
  // Set to true to hide the navigation elements to encourage the customer to focus
  hideNav?: boolean;
  //Set to true to add partner logo to navbar
  partnerLogo?: string;
  hideFooter?: boolean;
  children: React.ReactNode;
};

export const Layout = ({
  children,
  hideNav,
  partnerLogo,
  hideFooter,
}: Props) => {
  // We render these in reverse order to avoid having to specifically set a z-index
  // on the navigation container
  return (
    <div id="root" className="min-h-screen justify-end flex flex-col-reverse">
      {!hideFooter && <Footer />}
      <main>{children}</main>
      <Navigation hideNav={hideNav} partnerLogo={partnerLogo} />
    </div>
  );
};
